import { render, staticRenderFns } from "./Cita.vue?vue&type=template&id=5fb1e702"
import script from "./Cita.vue?vue&type=script&lang=js"
export * from "./Cita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports